// extracted by css-extract-rspack-plugin
export default {"mainChart":"Skeleton-module__mainChart__LEMoT","title":"Skeleton-module__title__bKjxz","subtitle":"Skeleton-module__subtitle__KMqV5"};